export default function AutocompleteInput({items, placeholder, onValueChange, onItemSelected, value, loadingText, isBig, isShowingClearIcon, onClearIconClick}) {
    console.log(items)
    let content
    if (loadingText) {
        content = <li key="loading">
        <div className="flex gap-x-2 content-center">
        <span className="loading loading-spinner loading-md"></span>
        <span className='font-normal text-base-content text-base'>{ loadingText }</span>
        </div>
    </li>
    } else {
        content = items.map((item) => {
            console.log(`item ${JSON.stringify(item)}`)
            return <li key={item.key}>
                <div className="flex flex-col gap-y-1 rounded-md" onMouseDown={() => { onItemSelected(item); }}>
                    <div className="w-full text-base font-bold">{ item.label }</div>
                    <div className="w-full text-sm font-normal">{ item.secondaryLabel }</div>
                </div>
            </li>
        })
    }
    let iconSize
    let iconPadding
    if (isBig) {
        iconSize = "w-6 h-6"
        iconPadding = `pl-16 input-lg ${isShowingClearIcon ? "pr-10" : ""}`
    } else {
        iconSize = "w-4 h-4 text-base"
        iconPadding = `pl-12 ${isShowingClearIcon ? "pr-10" : ""}`
    }
    return (
        <div className="dropdown w-full">
        <div className="form-control w-full relative">
            <svg className={`pointer-events-none absolute top-1/2 transform -translate-y-1/2 fill-none left-4 ${iconSize}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="stroke-base-content" d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <input className={`input input-bordered w-full rounded-md z-1 ${iconPadding}`} value={value} placeholder={placeholder} onChange={onValueChange} />
            {
                isShowingClearIcon && (
                    <button className="btn btn-circle btn-xs absolute top-1/2 right-2 transform -translate-y-1/2 " onClick={onClearIconClick}>
                    <svg className={`fill-none ${iconSize}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="fill-base-content" d="M6.99486 7.00636C6.60433 7.39689 6.60433 8.03005 6.99486 8.42058L10.58 12.0057L6.99486 15.5909C6.60433 15.9814 6.60433 16.6146 6.99486 17.0051C7.38538 17.3956 8.01855 17.3956 8.40907 17.0051L11.9942 13.4199L15.5794 17.0051C15.9699 17.3956 16.6031 17.3956 16.9936 17.0051C17.3841 16.6146 17.3841 15.9814 16.9936 15.5909L13.4084 12.0057L16.9936 8.42059C17.3841 8.03007 17.3841 7.3969 16.9936 7.00638C16.603 6.61585 15.9699 6.61585 15.5794 7.00638L11.9942 10.5915L8.40907 7.00636C8.01855 6.61584 7.38538 6.61584 6.99486 7.00636Z" fill="#0F0F0F"/>
                    </svg>
                    </button>
                )
            }
        </div>
        {
            (loadingText != null || items.length > 0) && <ul className="p-2 shadow menu dropdown-content z-[10] bg-base-100 rounded-box w-full text-base">
                { content }
            </ul>
        }
        </div>
      )
}
